import {SET_VIEW_SETTINGS} from "@actions/actionTypes";

export function setViewSettings(mode) {
    return dispatch => {
        dispatch({type: SET_VIEW_SETTINGS, mode});
    }
}